import { useContext } from 'react';
import { SelectionContext } from "../context/selection.js";
export const useSelection = () => useContext(SelectionContext);
//# sourceMappingURL=use-selection.js.map